// extracted by mini-css-extract-plugin
var _1 = "ProfileContactsWidgetListCell-modulecell__WYdgk";
var _2 = "ProfileContactsWidgetListCell-moduledivider__p3o1g Divider-moduleDivider__dL3Vg";
export { _1 as "cell", _2 as "divider" }
